import React, { useEffect, useState } from "react";
import styles from "./authlayout.module.scss";
import webLogo from "../../assets/images/web-logo.png";
import Proptypes from "prop-types";
import { Link } from "react-router-dom";

const AuthLayout = ({ hideSignupLabel, children }) => {
  const [url, setUrl] = useState(false);

  useEffect(() => {
    if (window.location.href.includes("seller")) {
      setUrl(true);
    } else {
      setUrl(false);
    }
  }, []);

  const isSignUpPage = window.location.href.includes("sign-up");

  return (
    <div className={styles["auth_container"]}>
      <div className={styles["auth_form"]}>
        <div className={styles["auth_logo"]}>
          <img src={webLogo} alt="web-logo" />
        </div>
        {children}
      </div>
      {url && (
        <>
          {isSignUpPage ? (
            <>
              <div className={styles["sign_up_container"]}>
                You have ready account?{" "}
                <Link to="/" className={styles["signup_link"]}>
                  <span className={styles["signup_text"]}>Signin</span>
                </Link>
              </div>
            </>
          ) : (
            <>
              <div className={styles["sign_up_container"]}>
                Don’t have an account?{" "}
                <Link to="/sign-up" className={styles["signup_link"]}>
                  <span className={styles["signup_text"]}>Signup</span>
                </Link>
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};

AuthLayout.propTypes = {
  children: Proptypes.node,
  hideSignupLabel: Proptypes.bool,
};

export default AuthLayout;
